import { useEffect } from 'react';

const usePreventNavigation = (history, path, enabled = true) => {
  useEffect(() => {
    if (!enabled) return undefined;

    const unblock = history.block((location, action) => {
      if (action === 'POP') {
        history.push(path);
        return false; // this prevents the navigation
      }
    });

    return () => {
      unblock();
    };
  }, [history, path, enabled]); // listening to changes in history, path, and enabled
};

export default usePreventNavigation;
